module.exports = __webpack_public_path__ + "img/redirectscreenshot.7025afb0.png";